<template>
    <form class="report-filter-form form-horizontal" >
        <div class="row">
            <div class="col-sm-12">
                <label for="dates">Rango de estadisticas.</label>
                <el-date-picker
                    id="dates"
                    unlink-panels
                    align="center"
                    class="d-block w-100"
                    v-model="dates"
                    type="daterange"
                    start-placeholder="Desde"
                    end-placeholder="Hasta"
                    :picker-options="pickerOptions">
                </el-date-picker>
                <input type="hidden" :value="getStartDate()" name="start_date" />
                <input type="hidden" :value="getEndDate()" name="end_date" />
            </div>
        </div>
        <br/>
        <div class="row">
            <div class="col-sm-offset-8 col-sm-4 text-right">
                <button type="submit" class="btn btn-primary">Filtrar</button>
            </div>
        </div>
    </form>
</template>
<script>

    import ElDatePicker from 'element-ui/lib/date-picker';

    export default {
        components: {
            ElDatePicker
        },
        methods: {
            getStartDate() {
                return moment(this.dates[0]).format('YYYY-MM-DD');
            },
            getEndDate() {
                return moment(this.dates[1]).format('YYYY-MM-DD');
            }
        },
        data() {
            let dates = [];

            if (this.startDate && this.endDate) {
                dates = [
                    moment(this.startDate, 'YYYY-MM-DD').toDate(),
                    moment(this.endDate, 'YYYY-MM-DD').toDate()
                ]
            }

            return {
                dates,
                pickerOptions: {
                    shortcuts: [
                        {
                            text: 'Semana',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Mes',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '3 meses',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ],
                    disabledDate(date) {
                        if (!date) return false; // Asegurarse de que la fecha no esté vacía
                        const minDate = moment('2023-07-01', 'YYYY-MM-DD');
                        return moment(date).isBefore(minDate);
                    }
                }
            }
        },
        props: ['value', 'start-date', 'end-date']
    }

</script>
